<script lang="ts" setup>
import BaseAddress from '@/components/molecules/BaseAddress.vue';
import { useWallet } from 'solana-wallets-vue';

const { connected, disconnect, publicKey } = useWallet();
</script>

<template>
  <div
    class="w-full flex flex-row justify-end items-center gap-4"
    v-if="connected"
  >
    <base-address
      v-if="publicKey"
      :address="publicKey.toString()"
      click-to-copy
      force-short
    ></base-address>
    <v-btn @click="disconnect">Disconnect</v-btn>
  </div>
</template>
